export enum EstruturaTipoAcao {
  RECONSTRUCAO = 'RECONSTRUCAO',
  SUBSTITUICAO_TOTAL = 'SUBSTITUICAO_TOTAL',
}
